<div class="activation-link-unlimited-voice">
  <form [formGroup]="form">
    <gdp-activation-link-form
      formControlName="activationData"
      [allowDiscount]="false"
      [allowWifi]="false"
      [loadingExternal]="loading"
    ></gdp-activation-link-form>

    <div class="addons-container" *ngIf="!loading && addonsError">
      <div class="error-section">
        <p class="error-message" translate>sales.unlimited-users.form.addons-error</p>
        <button class="vox-btn vox-btn-secondary" type="button" (click)="retryLoadAddons()">
          <span translate>sales.unlimited-users.form.retry-button</span>
        </button>
      </div>
    </div>

    <div class="addons-container" *ngIf="!loading && !addonsError">
      <div class="addons-section" formArrayName="requiredAddons">
        <div class="label-with-icon">
          <label class="section-label" translate>sales.unlimited-users.form.mandatory-addons</label>
          <i class="icon-small-info" [ngbTooltip]="'sales.unlimited-users.form.mandatory-addons-tooltip' | translate"></i>
        </div>
        <div>
          <gdp-activation-link-addon-card
            *ngFor="let addon of requiredAddonsControls; let i = index"
            [formControlName]="i"
            [name]="addon.value.name"
            [subtitle]="addon.value.id"
            [min]="addon.value.min"
            [max]="addon.value.max">
          </gdp-activation-link-addon-card>
        </div>
      </div>

      <div class="optional-addons-section">
        <div class="label-with-icon">
          <label class="section-label" translate>sales.unlimited-users.form.optional-addons</label>
          <i class="icon-small-info" [ngbTooltip]="'sales.unlimited-users.form.optional-addons-tooltip' | translate"></i>
        </div>
        <gdp-activation-link-addon-selector
          formControlName="optionalAddons"
          [availableAddons]="optionalAddons">
        </gdp-activation-link-addon-selector>
      </div>
      <div class="setup-fee-section">
        <label class="section-label" translate>sales.unlimited-users.form.setup-fee</label>
        <div class="setup-fee-options">
          <div *ngFor="let option of setupFeeOptions" class="setup-fee-option">
            <label class="setup-fee-label">
              <input
                type="radio"
                [value]="option"
                formControlName="setupFee"
                class="vox-radio setup-fee-radio">
              <gdp-activation-link-setup-fee
                [setupFee]="option"
                [isSelected]="option.id === form.get('setupFee')?.value?.id">
              </gdp-activation-link-setup-fee>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="addons-container" *ngIf="loading">
      <div class="addons-section">
        <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{'height':'60px'}"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{'height':'60px'}"></ngx-skeleton-loader>
      </div>

      <div class="addons-section">
        <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{'height':'60px'}"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{'height':'60px'}"></ngx-skeleton-loader>
      </div>

      <div class="addons-section">
        <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{'height':'60px'}"></ngx-skeleton-loader>
      </div>
    </div>

    <div class="submit-container">
      <button class="vox-btn vox-btn-primary" type="submit"
      [disabled]="form.invalid" (click)="onSubmit()"
      [ladda]="loadingSubmit">
        {{'sales.activation-link.form.button' | translate}}
      </button>
    </div>
  </form>
</div>

<ng-template #activationUnlimitedVoiceLinkPopup let-modal>
  <gdp-copy-feedback-popup
    [title]="'sales.copy-activation-link-modal.title' | translate"
    [feedback]="'sales.copy-activation-link-modal.link-copied' | translate"
    [content]="modalContent">
    <div class="link-container">
      <a [href]="modalContent" target="_blank" class="link">{{modalContent}}</a>
    </div>
  </gdp-copy-feedback-popup>
</ng-template>
